import script from "./ShopPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ShopPage.vue?vue&type=script&setup=true&lang=js"

import "./ShopPage.vue?vue&type=style&index=0&id=5aab7580&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5aab7580"]])

export default __exports__